export default __webpack_public_path__ + "static/media/light.8b764cdf.svg";